import React, { useEffect, useState } from "react";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import Messages from "./Reports/Messages";
import Requests from "./Reports/Requests";
import Inmates from "./Reports/Inmates";
import Photos from "./Reports/Photos";
import PostalMail from "./Reports/PostalMail";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction } from "../../_store";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useLocation } from "react-router-dom";
import generateMultiSheetXlsx from "../../components/common/export/Reports/generatemultipleXlsx";
import CustomLoader from "../../components/common/ui/Loader";

function InmateReports(ReportsAccordion) {
  const { noticeId, request, AdminRemedyFormHeader, inmate } = useSelector(
    (x) => x.inmate
  );
  const { user, commonFacilityCode: facilityCode } = useSelector((x) => x.auth);
  const [isloading, setisloading] = useState(false);
  const { photoList } = useSelector((x) => x.inmate);

  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  useEffect(() => {
    if (photoList?.DataList?.length > 0) {
      dispatch(inmateAction.setPhotoTotalCount(photoList?.TotalRecordCount));
    }
  }, [photoList]);

  const dispatch = useDispatch();

  const [messagesCheckBox, setMessagesCheckBox] = useState(false);
  const [requestCheckBox, setRequestCheckBox] = useState(false);
  const [inmateCheckBox, setInmateCheckBox] = useState(false);
  const [photosCheckBox, setPhotosCheckBox] = useState(false);
  const [postalMailCheckBox, setPostalMailCheckBox] = useState(false);

  const handleAccordian = async (e, position) => {
    const { checked } = e?.target;
    switch (position) {
      case 1:
        dispatch(inmateAction.clearMessageConversation());

        setMessagesCheckBox(checked);

        setRequestCheckBox(false);
        setInmateCheckBox(false);
        setPostalMailCheckBox(false);
        setPhotosCheckBox(false);
        break;

      case 2:
        await dispatch(inmateAction.clearVisitorData());

        setTimeout(() => {
          setRequestCheckBox(checked);
        }, 100);

        setMessagesCheckBox(false);
        setInmateCheckBox(false);
        setPostalMailCheckBox(false);
        setPhotosCheckBox(false);
        break;

      case 3:
        dispatch(inmateAction.clearInitiateMessageRecords());

        setInmateCheckBox(checked);

        setRequestCheckBox(false);
        setMessagesCheckBox(false);
        setPostalMailCheckBox(false);
        setPhotosCheckBox(false);
        break;

      case 4:
        dispatch(inmateAction.clearPhotoList());

        setPhotosCheckBox(checked);

        setInmateCheckBox(false);
        setRequestCheckBox(false);
        setMessagesCheckBox(false);
        setPostalMailCheckBox(false);

        break;
      case 5:
        dispatch(inmateAction.clearPostalMail());

        setPostalMailCheckBox(checked);

        setPhotosCheckBox(false);
        setInmateCheckBox(false);
        setRequestCheckBox(false);
        setMessagesCheckBox(false);

        // dispatch(inmateAction.LoadInmateLoginLogHistory(loginInfo));
        break;

      default:
        break;
    }
  };

  const handleExcel = async () => {
    handleAccordian({ target: { checked: false } }, 2);
    if (user?.Role === "FacilityStaffSAO") {
      return;
    }

    let msgParam = {
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      NoticesTitle: Inmate?.FirstName || inmate?.FirstName,
      MenuName: Inmate?.LastName || inmate?.LastName,
      UserFirstName: "",
      UserLastName: "",
      MessageDirection: 0,
      MessageFlag: 3,
      MessageSendStartDate: "",
      MessageSendEndDate: "",
    };

    let requestParam = {
      ...request,
      facilityID: request?.FacilityID,
      inmatesId: request?.InmatesId,
      requestFormTypeID: request?.RequestFormTypeID,
      managementUserID: user?.ManagementUserID,
      dobStartDate: request?.DobStartDate,
      dobEndDate: request?.DobEndDate,
    };

    let adminRemedyrequest = {
      ...request,
      Type: 2,
    };

    try {
      setisloading(true);
      const messageConversationdata =
        (await dispatch(
          inmateAction.MessageConversationInmate(msgParam)
        ).unwrap()) || [];
      const visitorsFormrecords =
        (await dispatch(
          inmateAction.InmateRequestVisitorInfo(noticeId || 0)
        ).unwrap()) || [];
      const adminRemedyForm = await Promise.all(
        AdminRemedyFormHeader.map((item) =>
          dispatch(
            inmateAction.LoadInmateRequestAdminRemedy(item.RequestFormTypeID)
          ).unwrap()
        )
      )
        .then((responses) => responses.flat()) // Flatten responses if needed
        .catch((error) => {
          console.error("Error fetching Admin Remedy Forms:", error);
          return []; // Return an empty array on failure
        });

      // (await dispatch(
      //   inmateAction.LoadInmateRequestAdminRemedy(noticeId || 0)
      // ).unwrap()) || [];

      const RFFFormRecords =
        (await dispatch(
          inmateAction.LoadRequestThreadInmateExport(requestParam)
        ).unwrap()) || [];
      const InitiateMessageRecords =
        (await dispatch(
          inmateAction.RequestFormTypeReport(adminRemedyrequest)
        ).unwrap()) || [];

      // Prepare multiple sheets data
      const sheetsData = [
        {
          sheetName: "Messages",
          data: messageConversationdata.map((obj) => ({
            "InmateResident ID": obj.InmateResidentId || "",
            "Inmate FullName": obj.InmateFullName || "",
            "Public User": obj.PublicUser || "",
            Sender: obj.Sender || "",
            "Message Subject": obj.MessageSubject || "",
            "Message Body": obj.MessageBody || "",
            "Receiver Read": obj.ReceiverRead || "",
            "Message Sent Date": obj.MessageSentDate || "",
            "Message Receive Date": obj.MessageReceiveDate || "",
          })),
          columns: [
            "InmateResident ID",
            "Inmate FullName",
            "Public User",
            "Sender",
            "Message Subject",
            "Message Body",
            "Receiver Read",
            "Message Sent Date",
            "Message Receive Date",
          ],
        },
        {
          sheetName: "Visitor",
          data: visitorsFormrecords.map((obj) => ({
            Date: obj.RequestCreateDate || "",
            "Inmate ID": obj.RequestVisitorFormID || "",
            Name: obj.VisitorName || "",
            POD: obj.POD || "",
            Action: obj.ReqApproved === 1 ? "Approved" : "DisApproved",
            VisitorName: obj.VisitorName || "",
            VisitorDOB: obj.DOB || "",
            VisitorRelation: obj.Relation || "",
            "VisitorPhone Number": obj.PhoneNo || "",
            VisitorAddress: obj.Address || "-",
            VisitorCity: obj.City || "",
            VisitorState: obj.StateName || "-",
            VisitorZip: obj.ZIP || "",
            VisitorDISAPPROVAL: obj.ReqDisApproved || "-",
            VisitorOthers: "-",
            "VisitorResubmit Date": obj.RequestReSubmitDate || "",
            "VisitorRespond Date": obj.RequestRespondDate || "",
          })),
          columns: [
            "Date",
            "Inmate ID",
            "Name",
            "POD",
            "Action",
            "VisitorName",
            "VisitorDOB",
            "VisitorRelation",
            "VisitorPhone Number",
            "VisitorAddress",
            "VisitorCity",
            "VisitorState",
            "VisitorZip",
            "VisitorDISAPPROVAL",
            "VisitorOthers",
            "VisitorResubmit Date",
            "VisitorRespond Date",
          ],
        },
        {
          sheetName: "Remedy",
          data: adminRemedyForm.map((obj) => ({
            "Inmate ID": obj.InmateID || "",
            Name: obj.InmateFullName || "",
            POD: obj.PodCode || "",
            Grievance:
              obj.GrvOriginal === 1
                ? "Original"
                : obj.GrvAppeal === 1
                  ? "Appeal"
                  : obj.GrvDisciplinaryActionAppeal === 1
                    ? "Disciplinary Action Appeal"
                    : "",
            Description: obj.GrievanceBody || "",
            "Received By": obj.GrievanceReceivedUser || "",
            "Date Received": obj.RequestCreateDate || "",
            Forwarded: "-",
            Investigation: "-",
            "Completed By": obj.InvestigationCompletedByUser || "",
            "Review Findings": "-",
            Date: obj.RequestCreateDate || "",
            "Supervisor Signature": obj.SupervisorSignature || "",
            Title: obj.SupervisorTitle || "",
            CountToWrite: "",
          })),
          columns: [
            "Inmate ID",
            "Name",
            "POD",
            "Grievance",
            "Description",
            "Received By",
            "Date Received",
            "Forwarded",
            "Investigation",
            "Completed By",
            "Review Findings",
            "Date",
            "Supervisor Signature",
            "Title",
            "CountToWrite",
          ],
        },
        {
          sheetName: "Requests",
          data: RFFFormRecords.map((obj) => ({
            "Form Type": obj.RequestFormType || "",
            "Inmate ID": obj.InmateResidentId || "",
            "Created By": obj.RequestCreateByName || "",
            "Request Body": obj.RequestBody || "",
            "Request Respond By": obj.RequestRespondBy || "",
            "Request Create Date": obj.ReqestCreateDate || "",
            "Request Post Date": obj.ReqestPostDate || "",
            CheckNewRow: "",
            RowHeader: "",
            PodCode: obj.PodCode || "",
            IsPostByInmate: obj.IsPostByInmate === 1 ? "Yes" : "No",
          })),
          columns: [
            "Form Type",
            "Inmate ID",
            "Created By",
            "Request Body",
            "Request Respond By",
            "Request Create Date",
            "Request Post Date",
            "CheckNewRow",
            "RowHeader",
            "PodCode",
            "IsPostByInmate",
          ],
        },
        {
          sheetName: "MGRequests",
          data: InitiateMessageRecords.map((obj) => ({
            "Form Type": obj.RequestFormType || "",
            "Inmate ID": obj.InmateResidentId || "",
            "Created By": obj.RequestCreateByName || "",
            "Request Body": obj.RequestBody || "",
            "Request Respond By": obj.RequestRespondBy || "",
            "Request Create Date": obj.ReqestCreateDate || "",
            "Request Post Date": obj.ReqestPostDate || "",
            CheckNewRow: "",
            RowHeader: "",
            PodCode: obj.PodCode || "",
            IsPostByInmate: obj.IsPostByInmate === 1 ? "Yes" : "No",
          })),
          columns: [
            "Form Type",
            "Inmate ID",
            "Created By",
            "Request Body",
            "Request Respond By",
            "Request Create Date",
            "Request Post Date",
            "CheckNewRow",
            "RowHeader",
            "PodCode",
            "IsPostByInmate",
          ],
        },
      ];

      // Generate Excel with multiple sheets
      generateMultiSheetXlsx(sheetsData, "Inmates Activities.xlsx");
      setisloading(false);
    } catch (error) {
      console.error("Error fetching data for Excel:", error);
    }
  };

  if (isloading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i className="fa fa-reorder"></i> Reports
          </h4>
          <div className="d-flex flex-wrap justify-content-end align-items-center ms-auto mb-1 gap-3">
            <div className="me-2">
              <ExcelExport
                handleExcelExport={handleExcel}
                label={"Export All Data"}
              />
            </div>
            <Button
              label="Back"
              type="button"
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                history.navigate("/Admin/InmateList"); // Clears location.state
                dispatch(inmateAction.clearInmate());
                dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
              }}
            />
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-message">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingMessage">
              <button
                className={`accordion-button 
                ${messagesCheckBox ? "" : "collapsed"} 
             text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian({ target: { checked: !messagesCheckBox } }, 1)
                }
              >
                Messages
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Messages"
                    name="messagesCheckBox"
                    id="messagesCheckBox"
                    handleClick={(e) => handleAccordian(e, 1)}
                    value={messagesCheckBox}
                    checked={messagesCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="message-accordion"
              className={`accordion-collapse ${messagesCheckBox ? "show" : "collapse"
                } p-3`}
              aria-labelledby="headingMessage"
            >
              <Messages loadData={false} render={!messagesCheckBox} />
            </div>
          </div>
        </div>
      </div>

      {!ReportsAccordion?.isRequestsInfo && (
        <div className="accordion" id="accordion-request">
          <div className="accordion-item border-0">
            <div className="card mb-3">
              <div className="accordion-header" id="headingRequest">
                <button
                  className={`accordion-button  
                ${requestCheckBox ? "" : "collapsed"} 
                text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                  type="button"
                  aria-expanded={true}
                  onClick={() =>
                    handleAccordian(
                      { target: { checked: !requestCheckBox } },
                      2
                    )
                  }
                >
                  Requests/Grievances
                  {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Request/Grievance"
                    name="requestCheckBox"
                    id="requestCheckBox"
                    handleClick={(e) => handleAccordian(e, 2)}
                    value={requestCheckBox}
                    checked={requestCheckBox}
                  />
                </span> */}
                </button>
              </div>
              <div
                id="request-accordion"
                className={`accordion-collapse ${requestCheckBox ? "show" : "collapse"
                  } p-3`}
                aria-labelledby="headingRequest"
              >
                <Requests loadData={false} render={!requestCheckBox} />
              </div>
            </div>
          </div>
        </div>
      )}

      {!ReportsAccordion?.isInitiate && (
        <div className="accordion" id="accordion-inmate">
          <div className="accordion-item border-0">
            <div className="card mb-3">
              <div className="accordion-header" id="headingInmate">
                <button
                  className={`accordion-button 
                ${!inmateCheckBox ? "collapsed" : ""} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                  type="button"
                  aria-expanded={true}
                  onClick={() =>
                    handleAccordian({ target: { checked: !inmateCheckBox } }, 3)
                  }
                >
                  Initiate Message To Inmate
                  {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Initiate Message To Inmate"
                    name="inmateCheckBox"
                    id="inmateCheckBox"
                    handleClick={(e) => handleAccordian(e, 3)}
                    value={inmateCheckBox}
                    checked={inmateCheckBox}
                  />
                </span> */}
                </button>
              </div>
              <div
                id="inmate-accordion"
                className={`accordion-collapse ${inmateCheckBox ? "show" : "collapse"
                  } p-3`}
                aria-labelledby="headingInmate"
              >
                {/* <div className="accordion-body p-0 m-4"> */}
                <Inmates loadData={false} render={!inmateCheckBox} />
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="accordion" id="accordion-photos">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingPhotos">
              <button
                className={`accordion-button 
                ${photosCheckBox ? "" : "collapsed"} 
             text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian({ target: { checked: !photosCheckBox } }, 4)
                }
              >
                Photos
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Photos"
                    name="photosCheckBox"
                    id="photosCheckBox"
                    handleClick={(e) => handleAccordian(e, 4)}
                    value={photosCheckBox}
                    checked={photosCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="photos-accordion"
              className={`accordion-collapse ${photosCheckBox ? "show" : "collapse"
                } p-3`}
              aria-labelledby="headingPhotos"
            >
              <Photos loadData={false} render={!photosCheckBox} />
            </div>
          </div>
        </div>
      </div>

      {!ReportsAccordion?.isPostalMail && (
        <div className="accordion" id="accordion-postalmail">
          <div className="accordion-item border-0">
            <div className="card mb-3">
              <div className="accordion-header" id="headingPostalMail">
                <button
                  className={`accordion-button 
                ${postalMailCheckBox ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                  type="button"
                  aria-expanded={true}
                  onClick={() =>
                    handleAccordian(
                      { target: { checked: !postalMailCheckBox } },
                      5
                    )
                  }
                >
                  {" "}
                  Postal Mails
                  {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Postal Mail"
                    name="postalMailCheckBox"
                    id="postalMailCheckBox"
                    handleClick={(e) => handleAccordian(e, 5)}
                    value={postalMailCheckBox}
                    checked={postalMailCheckBox}
                  />
                </span> */}
                </button>
              </div>
              <div
                id="postalmail-accordion"
                className={`accordion-collapse ${postalMailCheckBox ? "show" : "collapse"
                  } p-3`}
                aria-labelledby="headingPostalMail"
              >
                <PostalMail loadData={false} render={!postalMailCheckBox} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(InmateReports);
